import { RawListingData } from '../Listing/types';
import { JSONObject } from '../Api/types';
import { ProcessStatus } from '../types';

export enum SuggestionType {
  ALL = 'All',
  ORIGINAL = 'Original',
  SET = 'Set',
  FAKE = 'Fake'
}

export interface RawListingDataSuggestion {
  id: string;
  listing_id: string;
  listing: RawListingData;
  data: JSONObject;
  status: ProcessStatus;
}
